<template>
  <p class="body mb-1 d-flex align-items-center gap-2">
    <CalendarIcon />
    {{ d(bookingOption.startDate) }} {{ t('reservations.until') }}
    {{ d(bookingOption.endDate) }}
  </p>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n'
  import CalendarIcon from '@/assets/CalendarIcon.vue'

  // Props
  defineProps({
    bookingOption: {
      type: Object,
      required: true,
      validator: (value: any) => {
        return value && value.startDate && value.endDate && value.prestTypeId === 1
      }
    }
  })

  // i18n setup
  const { t, d } = useI18n()
</script>

<style scoped></style>
